import React from 'react';
import { cn } from './cn';
import { Loader } from '../../icons';

const VARIANTS = {
  primary:
    'bg-accent text-[#062A24] hover:bg-accent-bright active:bg-accent-dim shadow-[0_6px_18px_-6px_rgba(20,211,176,0.6)] font-semibold',
  secondary:
    'bg-card-2 text-primary border border-line hover:border-line-strong hover:bg-[#2A3850] active:bg-card',
  ghost: 'bg-transparent text-secondary hover:text-primary hover:bg-white/5 active:bg-white/10',
  danger:
    'bg-danger-soft text-danger border border-danger/30 hover:bg-danger/25 active:bg-danger/30',
  'danger-solid': 'bg-danger text-white hover:bg-[#E03B49] font-semibold',
};

const SIZES = {
  sm: 'h-9 px-3 text-sm gap-1.5 rounded-lg',
  md: 'h-11 px-4 text-[15px] gap-2 rounded-xl',
  lg: 'h-12 px-5 text-base gap-2 rounded-xl',
  icon: 'h-11 w-11 p-0 rounded-xl',
  'icon-sm': 'h-9 w-9 p-0 rounded-lg',
};

/**
 * Button primitive. Full class strings per variant so Tailwind can purge safely.
 */
const Button = React.forwardRef(function Button(
  {
    variant = 'secondary',
    size = 'md',
    loading = false,
    disabled,
    className,
    children,
    type = 'button',
    ...rest
  },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap select-none font-medium transition-colors duration-150',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 focus-visible:ring-offset-2 focus-visible:ring-offset-page',
        'disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none',
        VARIANTS[variant] || VARIANTS.secondary,
        SIZES[size] || SIZES.md,
        className
      )}
      {...rest}
    >
      {loading && <Loader className="w-4 h-4 animate-spin" />}
      {children}
    </button>
  );
});

export default Button;
